import type { AppleChannelProductPagesOptionsResponse } from "@redbox-ruby/data-lib";
import type { RubyCountry, RubyProductPage } from "../services/backend/RubyData";
import { getCountryCodeByLanguage } from "./country";

export function prepareProductPages(pages: AppleChannelProductPagesOptionsResponse["productPages"]): RubyProductPage[] {
    return pages.map(({ productPage, locales }) => ({
        ...productPage,
        locales: locales
            .filter((locale) => Object.keys(locale.appPreviewDeviceWithAssets ?? {}).length > 0)
            .map((locale) => {
                // Platform API provides this explicitly; older replica snapshots use assetGenId.
                const languageCode = (locale as typeof locale & { languageCode?: string }).languageCode;
                const explicitCountry = languageCode?.match(/[-_]([A-Z]{2})$/)?.[1];
                if (explicitCountry) return { ...locale, countryCode: explicitCountry as RubyCountry };

                let countryCode = (getCountryCodeByLanguage(locale.language) || "GB") as RubyCountry;
                Object.values(locale.appPreviewDeviceWithAssets ?? {}).forEach((assets) => {
                    (assets.screenshots ?? []).forEach((screen) => {
                        const match = screen.assetGenId?.split(";")[1]?.match(/^(\w{2,}-)*([A-Z]{2})$/);
                        countryCode = (match?.[match.length - 1] || countryCode) as RubyCountry;
                    });
                });
                return { ...locale, countryCode };
            }),
    }));
}
